<template>
  <div class="modal fade" id="agentsRemark" role="dialog">
    <div class="modal-dialog modal-dialog-centered model-lg">
      <div class="modal-content">
        <div class="modal-body text-center">
          <div class="col-12 text-center mt-5">
            <img
              src="@/assets/images/danger.png"
              alt="danger"
              class="danger-icon"
            />
          </div>
          <p class="mt-2 mb-0">This Proposal would be referred</p>
          <p>
            basis <span class="font-weight-bold">underwriting guidelines</span>
          </p>
          <div class="form-group col-12 p-0">
            <float-label label="Agents Remark">
              <textarea
                type="text"
                rows="4"
                cols="30"
                class="form-control"
                placeholder="Agents Remark"
              ></textarea>
            </float-label>
          </div>
        </div>
        <div class="col-12 text-right mb-5">
          <button
            type="button"
            id="cancel"
            class="btn bgc-btn-primary mr-3"
            data-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            id="ok"
            class="btn bgc-btn-secondary mr-3 w-25"
            data-dismiss="modal"
            @click="agentsRemark()"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import { reactive } from "@vue/composition-api";
export default {
  name: "AgentsRemark",
  components: {
    FloatLabel,
  },
  setup(props, { parent }) {
    let state = reactive({});
    function agentsRemark() {
      parent.agentsRemark();
    }
    // function approveCancelPolicy(){
    //   parent.approveCancelPolicy();
    // }
    return {
      state,
      agentsRemark,
      // approveCancelPolicy
    };
  },
};
</script>

<style scoped>
.modal-head {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  margin: 28px 5px 12px 5px;
  justify-content: space-between;
}
.btn:hover {
  color: #ffffff;
}
.vfl-has-label {
  position: relative;
  width: 100%;
}
</style>